import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import axios from 'axios'

class PrivacyPolicyOwnerAdd extends React.Component {
  state = {
    isData: false,
    privacy_policy_owner_en: '',
    privacy_policy_owner_ar: '',
  }

  componentDidMount() {
    this.PrivacyPolicy()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language_id !== this.props.language_id) {
      this.PrivacyPolicy()
    }
  }

  PrivacyPolicy = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/client/get-client-settings/privacy-policy-owner`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        that.setState(res.data.data)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (value) => {
    this.setState({ privacy_policy_owner_en: value, privacy_policy_owner_ar: value })
  }

  onSave = () => {
    var data
    if (this.props.language_id === 'en') {
      data = {
        id: this.state.id,
        privacy_policy_owner_en: this.state.privacy_policy_owner_en,
      }
    } else {
      data = {
        id: this.state.id,
        privacy_policy_owner_ar: this.state.privacy_policy_owner_ar,
      }
    }

    this.setState({ isData: true })

    axios
      .post(Constant.getAPI() + '/client/update-client-settings', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Policy Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="card-body">
        <div className="row">
          <div className="col-12 ">
            {this.props.language_id === 'en' ? (
              <ReactQuill
                value={this.state.privacy_policy_owner_en}
                onChange={this.handleChange}
              />
            ) : (
              <ReactQuill
                value={this.state.privacy_policy_owner_ar}
                onChange={this.handleChange}
              />
            )}
          </div>
        </div>
        <div className="card-footer">
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button
                className="btn btn-grd-disabled mr-2"
                disabled
              >
                Saving...!
              </button>
            ) : (
              <button
                onClick={this.onSave}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save{' '}
              </button>
            )}
            <Link
              to={'/refund-policy'}
              className="btn btn-outline-dark"
            >
              {' '}
              Cancel{' '}
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default PrivacyPolicyOwnerAdd
